import { Button, Dropdown } from '@ibsys/kit';
import { ChevronDownIcon, PlayIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CONVERSATION_PIPELINE_OPTIONS, type ConversationPipeline } from '@/entities/search';

type Props = {
  /** Есть ли что запускать: выбраны строки или включено «выбрать все» */
  hasSelection: boolean;
  /** Запуск обработки уже идёт — повторный запуск заблокирован */
  isPending: boolean;
  /** Запуск выбранной обработки по всей выбранной выборке */
  onRun: (pipeline: ConversationPipeline) => void;
  className?: string;
};

/**
 * Блок массовых действий над диалогами: выпадающий список обработок
 * из общего перечня {@link CONVERSATION_PIPELINE_OPTIONS}.
 * Без выбора и во время запроса — заблокирован.
 */
export const PipelineActions: FC<Props> = ({ hasSelection, isPending, onRun, className }) => {
  const { t } = useTranslation(['dialogs', 'common']);

  return (
    <Dropdown
      options={CONVERSATION_PIPELINE_OPTIONS.map((option) => ({
        key: option.value,
        type: 'item' as const,
        title: t(option.labelKey),
        onClick: () => onRun(option.value),
      }))}
    >
      <Button variant="secondary" size="sm" className={className} disabled={!hasSelection || isPending}>
        <PlayIcon className="size-4" />
        {t('dialogs:dialogListSection.runPipeline.actions.label')}
        <ChevronDownIcon className="size-4" />
      </Button>
    </Dropdown>
  );
};
